<template>

  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <main-view>
          </main-view>
        </div>
        
      </div>
    </div>
  </div>
</template>
<script>
  import MainView from './PostModules/HomeInfos/Index.vue'

export default {
    components: {
      MainView
    },
    data: function () {
      return {
        navigation: true
      }
    },
    methods: {
  
    }
  }
</script>
<style>
#new-post{
  background-color:rgba(255,255,255,.9);
}
.fas {
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/HomeInfos.vue